import { TemplateId } from "./general";

export type RecordPrimaryKey = number | string;
export type NotificationId = number;

export type TemplateNotification = {
  notificationId: NotificationId;
  notificationTemplateId: number;
  label: string;
  overviewTemplateId: TemplateId;
  detailTemplateId: number;
  recordPrimaryKey: RecordPrimaryKey;
  primaryColumnName: string;
  notificationIsTask: boolean;
  isRead: boolean;
};

export type SystemMappingNotification = {
  notificationId: NotificationId;
  type: "mapping";
  datasourceId: number;
  datasourceName: string;
  notificationTemplateId: number;
  overviewTemplateId: number;
  templateName: string;
  ewaUserId: number;
  isRead: boolean;
};

export type SystemAdminNotification = {
  notificationId: NotificationId;
  label: string;
  type: "notificationTemplate" | "defaultMapping";
  dataIds: number[];
  isRead: boolean;
};

export type SystemNotification = SystemMappingNotification;

export type SignalRNotification =
  | TemplateNotification
  | SystemNotification
  | SystemAdminNotification;

const x = {
  type: "NOTIFICATIONS:RECEIVE_ALL_MESSAGES",
  payload: {
    notifications: [
      {
        label: "notifikace",
        templateId: 3034,
        detailTemplateId: 5040,
        notificationId: 1337,
        recordPrimaryKey: 1338,
        primaryColumnName: "1339",
        notificationIsTask: true,
      },
      {
        label: "notifikace",
        templateId: 3034,
        detailTemplateId: 5040,
        notificationId: 1337,
        recordPrimaryKey: 1338,
        primaryColumnName: "1339",
        notificationIsTask: true,
      },
      {
        label: "notifikace",
        templateId: 3034,
        detailTemplateId: 5040,
        notificationId: 1337,
        recordPrimaryKey: 1338,
        primaryColumnName: "1339",
        notificationIsTask: true,
      },
    ],
  },
};
